import { mapGetters } from 'vuex'
import provinceHelpers from '../helpers/provinceHelpers'
import subscriptionHelpers from '../helpers/subscriptionHelpers'
import packageHelpers from '../helpers/packageHelpers'

export const checkoutCostMixin = {
  data () {
    return {
      subtotal: 0,
      discountCost: 0,
      creditDiscountCost: null,
      extraCost: null,
      serviceVat: 0,
      totalPrice: 0,
      count: 0
    }
  },
  computed: {
    ...mapGetters({
      appliedExtras: 'extras/getAppliedExtras',
      appliedPromoCode: 'promoCode/getAppliedPromoCode',
      globalState: 'globalVal/getState',
      hasAppliedExtras: 'extras/getHasAppliedExtras',
      preBookingData: 'booking/getPreBookingData',
      preCheckoutData: 'booking/getPreCheckoutData',
      state: 'booking/getState'
    })
  },
  watch: {
    appliedExtras () {
      this.calculateServiceCost()
    },
    appliedPromoCode () {
      this.calculateServiceCost()
    },
    'preCheckoutData.is_credit': function (newVal, oldVal) {
      this.calculateServiceCost()
    },
    'state.totalPrice': function (newVal, oldVal) {
      this.calculateServiceCost()
    }
  },
  methods: {
    calculateServiceCost () {
      if (this.state && this.state.totalPrice) {
        const numbers = this.$options.filters.serviceCost(this.state, this.preCheckoutData, this.appliedPromoCode)
        if (numbers) {
          this.subtotal = numbers[0]
          this.discountCost = numbers[1]
          this.serviceVat = numbers[2]
          this.creditDiscountCost = numbers[3]
          this.totalPrice = numbers[4]
          // Check subscription
          if (this.preBookingData && this.preBookingData.subscription_type_id) {
            const totalCredits = (this.preCheckoutData && this.preCheckoutData.total_credits) ? Number(this.preCheckoutData.total_credits) : null
            this.getSubscriptionCost(totalCredits)
          }

          // Check package
          if (this.preBookingData && this.preBookingData.package_type) {
            const totalCredits = (this.preCheckoutData && this.preCheckoutData.total_credits) ? Number(this.preCheckoutData.total_credits) : null
            this.getPackageCost(totalCredits)
          }
        }
      }
    },
    getSubscriptionCost (creditDiscountCost) {
      const subscriptionType = subscriptionHelpers.getSubscriptionTypeData(this.globalState.subscriptionTypes, this.preBookingData.subscription_type_id)
      const numPerMonth = subscriptionType.num_per_month
      const provinceId = this.preBookingData.province_id
      const costPerHour = Number(this.globalState.provinceWages[provinceId].cost_per_hour)
      let workHour = Number(this.preBookingData.work_hour)

      // Extra service
      if (this.preCheckoutData && this.preCheckoutData.extra) {
        workHour = workHour - this.preCheckoutData.extra.work_hour
        this.extraCost = this.preCheckoutData.extra.cost * numPerMonth
      }

      let tmpSubtotal = costPerHour * workHour

      // Check province discount
      const discount = provinceHelpers.getProvinceDiscount(this.globalState.provinceDiscounts, provinceId, workHour)
      if (discount) {
        let discountCost = (tmpSubtotal * discount) / 100
        discountCost = Math.round(discountCost * 100) / 100
        tmpSubtotal -= discountCost
      }

      // Add extra service cost
      if (this.preCheckoutData && this.preCheckoutData.extra) {
        tmpSubtotal += Number(this.preCheckoutData.extra.cost)
      }

      // Num orders in package
      tmpSubtotal *= numPerMonth
      this.subtotal = tmpSubtotal

      this.discountCost = (tmpSubtotal * subscriptionType.discount) / 100
      this.discountCost = Math.round(this.discountCost * 100) / 100
      tmpSubtotal -= this.discountCost

      this.serviceVat = tmpSubtotal * this.globalState.serviceVat
      this.serviceVat = Math.round(this.serviceVat * 100) / 100
      tmpSubtotal += this.serviceVat

      // Check applying coin discount
      if (this.preCheckoutData && this.preCheckoutData.is_credit && creditDiscountCost !== null) {
        if (creditDiscountCost >= tmpSubtotal) {
          this.creditDiscountCost = tmpSubtotal
        } else {
          this.creditDiscountCost = creditDiscountCost
        }
        tmpSubtotal -= this.creditDiscountCost
      }

      this.totalPrice = tmpSubtotal
    },
    getPackageCost (creditDiscountCost) {
      const packageType = this.preBookingData.package_type
      const packageTypeDiscount = this.preBookingData.package_type_discount
      let numPerPackage = 1
      const category = this.preBookingData.package_type.category
      if (category === 'unlimited') {
        numPerPackage = this.preBookingData.multi_dates_times.length
      } else if (category === 'flexible') {
        numPerPackage = packageTypeDiscount.booking_qty
      }

      let tmpSubtotal = 0
      if (this.preBookingData.service_id === 1) {
        const provinceId = this.preBookingData.province_id
        const costPerHour = Number(this.globalState.provinceWages[provinceId].cost_per_hour)
        let workHour = Number(this.preBookingData.work_hour)

        // Extra service
        if (this.preCheckoutData && this.preCheckoutData.extra) {
          workHour = workHour - this.preCheckoutData.extra.work_hour
          this.extraCost = this.preCheckoutData.extra.cost * numPerPackage
        }

        tmpSubtotal = costPerHour * workHour
        // Check province discount
        const discount = provinceHelpers.getProvinceDiscount(this.globalState.provinceDiscounts, provinceId, workHour)
        if (discount) {
          let discountCost = (tmpSubtotal * discount) / 100
          discountCost = Math.round(discountCost * 100) / 100
          tmpSubtotal -= discountCost
        }

        // Add extra service cost
        if (this.preCheckoutData && this.preCheckoutData.extra) {
          tmpSubtotal += Number(this.preCheckoutData.extra.cost)
        }
      } else {
        tmpSubtotal = Number(this.globalState.services[this.preBookingData.service_id].cost)
      }

      // Num orders in package
      tmpSubtotal *= numPerPackage
      this.subtotal = tmpSubtotal

      // Check package type discount
      let packageDiscountValue = packageType.discount
      if (packageType.category === 'unlimited') {
        const packageTypeDiscount = packageHelpers.getUnlimitedPackageDiscount(packageType, numPerPackage)
        if (packageTypeDiscount) {
          packageDiscountValue = packageTypeDiscount.discount
        } else {
          packageDiscountValue = 0
        }
      } else if (packageType.category === 'flexible') {
        packageDiscountValue = packageTypeDiscount.discount
      }

      // Apply package type discount
      if (packageDiscountValue > 0) {
        this.discountCost = (tmpSubtotal * packageDiscountValue) / 100
        this.discountCost = Math.round(this.discountCost * 100) / 100
        tmpSubtotal -= this.discountCost
      }

      this.serviceVat = tmpSubtotal * this.globalState.serviceVat
      this.serviceVat = Math.round(this.serviceVat * 100) / 100
      tmpSubtotal += this.serviceVat

      // Check applying coin discount
      if (this.preCheckoutData && this.preCheckoutData.is_credit && creditDiscountCost !== null) {
        if (creditDiscountCost >= tmpSubtotal) {
          this.creditDiscountCost = tmpSubtotal
        } else {
          this.creditDiscountCost = creditDiscountCost
        }
        tmpSubtotal -= this.creditDiscountCost
      }

      this.totalPrice = tmpSubtotal
    }
  },
  mounted () {
    this.calculateServiceCost()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/checkoutCostMixin.js